"use client";

import { Card } from "@/app/_module/components/ui/card";
import type { LucideIcon } from "lucide-react";

/**
 * Instruction-only "available on the web version" card shown in the NATIVE app
 * in place of purchase/billing surfaces (store-review safety: no purchase UI,
 * no pricing, no link-out — deliberate, see vault mobile-app note 2026-08-27).
 * Wording rule: never mention buying, prices, or upgrading.
 */
export function WebOnlyNotice({
  icon: Icon,
  title,
  message,
}: {
  icon: LucideIcon;
  title: string;
  message: string;
}) {
  return (
    <Card className="p-8 text-center">
      <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-primary/10">
        <Icon className="h-6 w-6 text-primary" />
      </div>
      <h3 className="text-lg font-semibold text-foreground">{title}</h3>
      <p className="mx-auto mt-2 max-w-sm text-sm text-muted-foreground">{message}</p>
    </Card>
  );
}
